import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

const useSendReminderMutation = () => {
  const { mutateAsync, isPending } = ApprovalFlows.notifyParties();

  const sendReminder = (approvalProcessId: string) =>
    mutateAsync({ urlParams: { requestId: approvalProcessId } });

  return { mutateAsync: sendReminder, isPending };
};

export default useSendReminderMutation;
